import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { TranslateModule } from '@ngx-translate/core';
import { CdpComponent } from './cdp.component';
import { CdpRoutingModule } from './cdp.routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HelpComponent } from './components/help/help.component';
import { SharedModule } from '../shared/shared.module';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { AppPagesComponent } from './components/app-pages/app-pages.component';

@NgModule({
  declarations: [
    CdpComponent,
    HomeComponent,
    HelpComponent,
    CopyrightComponent,
    AppPagesComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CdpRoutingModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class CdpModule { }
